import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useNotificationPreferences from './hooks/useNotificationPreferences';
import { isAdmin } from '../../lib/utils/roles';
import NotificationSection from './components/NotificationSection';
import { useNotificationConfig } from './config/notificationConfig';
import SectionCard from '../../shared/SectionCard';
import styles from './NotificationPreferences.module.css';

export default function NotificationPreferences() {
  const { t } = useTranslation('accountSettings');
  const { userType } = useSelector(state => state.currentUser);
  const isUserAdmin = isAdmin(userType);

  const { values, handleChange, isLoading } = useNotificationPreferences();

  const handleRowClick = fieldName => {
    handleChange({
      target: { name: fieldName, checked: !values[fieldName] },
    });
  };

  const notificationConfig = useNotificationConfig(isUserAdmin);

  if (isLoading) {
    return (
      <SectionCard title={t('notificationPreferences.title')}>
        <div className={styles.container}>
          <div>Loading...</div>
        </div>
      </SectionCard>
    );
  }

  return (
    <SectionCard title={t('notificationPreferences.contactPreferencesTitle')}>
      <NotificationSection
        items={notificationConfig.preferences.items}
        values={values}
        onChange={handleChange}
        onItemClick={handleRowClick}
      />
    </SectionCard>
  );
}
